import { SchoolSettingForm } from "../SettingForm";
import { useTenantAuth } from "../../../../../context/TeanantAuthProvider";
import CommonLoader from "../../../../common/CommonLoader";

/**
 * AdminProfilePage - Settings page content for Admin Profile
 * Renders inside SettingsLayout via Outlet
 */
const AdminProfilePage = () => {
  const { currentUser, loading } = useTenantAuth();

  return (
    <div className="row">
      {loading ? (
        <CommonLoader loadingMessage="Loading user details..." />
      ) : (
        <SchoolSettingForm users={currentUser} />
      )}
    </div>
  );
};

export default AdminProfilePage;
